export default "__VITE_ASSET__C89aGK_L__"